import { lazyLoad } from 'utils/loadable';

export const TemplateSetting = lazyLoad(
  () => import('./index'),
  module => module.TemplateSetting,
); 